class Dropdown {

  constructor(dropdown) {
    this.dropdown = dropdown;

    this.init();
  }


  init() {
    const [toggler, menu, visibleMenu] = this.dropdown.children;

    let activeMenu = menu;
    if (visibleMenu) {
      activeMenu = visibleMenu;
    }

    const handleClickOut = e => {
      if(!this.dropdown) {
        return document.removeEventListener('click', handleClickOut);
      }

      if(!this.dropdown.contains(e.target)) {
        this.toggle(false);
      }
    };

    const setValue = () => {
      let togglerNum = toggler.querySelector('.dropdown-num');
      let num = menu.querySelectorAll('input:checked').length;

      if (togglerNum) {
        if (num === 0) {
          togglerNum.innerHTML = '';
        } else {
          togglerNum.innerHTML = ' (' + num + ')';
        }
      }

      this.dropdown.dispatchEvent(new Event('change'));
    }

    const setValueTx = (item) => {
      if (this.dropdown.classList.contains('dropdown-download') ||
        this.dropdown.classList.contains('dropdown-sort-by') ||
        this.dropdown.classList.contains('webform-dropdown')) {
        const val = item.textContent;
        toggler.querySelector('.dropdown-toggle-tx').textContent = val;
        this.value = val;
        this.toggle(false);
        this.dropdown.dispatchEvent(new Event('change'));
        toggler.focus();
      }
    }

    const updateValue = (select, index) => {
      const nativeWidget = select.previousElementSibling;
      const visibleSelect = select.previousElementSibling.previousElementSibling.parentElement;
      const value = visibleSelect.querySelector('.dropdown-toggle-tx');
      const optionList = visibleSelect.querySelectorAll('.dropdown-item');

      optionList.forEach((other) => {
        other.setAttribute('aria-selected', 'false');
      })

      optionList[index].setAttribute('aria-selected', 'true');

      nativeWidget.selectedIndex = index;
      value.innerHTML = optionList[index].querySelector('label').innerHTML;
    }

    const handleItemKeyDown = (e) => {
      e.preventDefault();

      if(e.keyCode === 38 && e.target.previousElementSibling) { // up
        e.target.previousElementSibling.focus();
      } else if(e.keyCode === 40 && e.target.nextElementSibling) { // down
        e.target.nextElementSibling.focus();
      } else if(e.keyCode === 27) { // escape key
        this.toggle(false);
      } else if(e.keyCode === 13 || e.keyCode === 32) { // enter or spacebar key
        e.target.querySelector('input').click();
      }
    }

    const handleToggleKeyPress = (e) => {
      if(e.keyCode === 27) { // escape key
        e.preventDefault();
        this.toggle(false);
      } else if(e.keyCode === 13 || e.keyCode === 32) { // enter or spacebar key
        e.preventDefault();
        this.toggle(true);
      }
    }


    toggler.addEventListener('keydown', handleToggleKeyPress);
    toggler.addEventListener('click', () => this.toggle());
    [...activeMenu.children].forEach((item, index) => {
      item.addEventListener('keydown', handleItemKeyDown);
      item.addEventListener('click', () => {
        setValueTx(item);
        if (activeMenu.classList.contains('webform-select')) {
          updateValue(activeMenu, index);
        }
      });
    });

    this.element = this.dropdown;

    this.value = toggler.querySelector('.dropdown-toggle-tx').textContent;

    this.toggle = (expand = null) => {
      expand = expand === null
        ? activeMenu.getAttribute('aria-expanded') !== 'true'
        : expand;

      activeMenu.setAttribute('aria-expanded', expand);

      if(expand) {
        toggler.classList.add('active');
        activeMenu.children[0].focus();
        document.addEventListener('click', handleClickOut);
        this.dropdown.dispatchEvent(new Event('opened'));
      } else {
        toggler.classList.remove('active');
        toggler.focus();
        if (!this.dropdown.classList.contains('dropdown-download') && !this.dropdown.classList.contains('webform-dropdown')) {
          setValue();
        }
        this.dropdown.dispatchEvent(new Event('closed'));
        document.removeEventListener('click', handleClickOut);
      }// if else is expand
    }// toggle

  }// init

}

export default Dropdown;
